import React from 'react';
import { Tag, Tooltip } from 'antd';
import { Influencer } from '../../../../services/marketingAPI';

const formatNumber = (num: number, digits = 1) => {
    if (num >= 100000000) return (num / 100000000).toFixed(digits) + '亿';
    if (num >= 1000000) return (num / 1000000).toFixed(digits) + 'M';
    if (num >= 10000) return (num / 10000).toFixed(digits) + 'w';
    if (num >= 1000) return (num / 1000).toFixed(digits) + 'K';
    return num.toString();
};

export const FollowersCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile) return <span>-</span>;
    return <div style={{ fontWeight: 'bold' }}>{formatNumber(mainProfile.follower_count)}</div>;
};

export const TotalViewsCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile) return <span>-</span>;
    const num = mainProfile.total_views || 0;
    const display = num > 0 ? num.toLocaleString() : '-';
    // Use simple truncation for very large numbers if needed, but here we just use locale string or previously defined logic?
    // Let's stick to the logic from original file
    let formatted = display;
    if (num >= 100000000) formatted = (num / 100000000).toFixed(2) + '亿';
    else if (num >= 10000) formatted = (num / 10000).toFixed(1) + 'w';

    return <div>{formatted}</div>;
};

export const AvgViewsCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile) return <span>-</span>;
    const num = mainProfile.avg_video_views || 0;
    let display = num > 0 ? num.toLocaleString() : '-';
    if (num >= 10000) display = (num / 10000).toFixed(1) + 'w';
    return <div>{display}</div>;
};

export const EngagementCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile) return <span>-</span>;

    const rate = mainProfile.avg_engagement_rate;
    const percent = (rate * 100).toFixed(2) + '%';

    return <Tag color={rate > 0.05 ? 'green' : rate > 0.02 ? 'orange' : 'default'}>{percent}</Tag>;
};

export const VideoCountCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile || !mainProfile.video_count) return <span style={{ color: '#ccc' }}>-</span>;
    return <span>{mainProfile.video_count.toLocaleString()}</span>;
};
